/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Head from 'react-helmet';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import { Redirect } from 'react-router-dom';
import styled from '@emotion/styled';

import { login } from 'store/auth/auth-actions';

import Box from 'components/box';
import { Alert } from 'components/alerts';
import Button from 'components/button';
import { TextField } from 'components/inputs';
import BrandedLogo from 'components/branded-logo';
import ehaiLogo from 'assets/images/ehis-logo.webp';
import { DEFAULT_PATHS_FOR_ROLE, featureFlags, ROLES } from '../lib/config';
import { userSelector } from 'store/auth/auth-selectors';

/**
 * Styles
 */

const Centered = styled(Box)`
  background: ${props => props.theme.colors.gray[0]};
  height: 100vh;
`;

const Panel = styled.div`
  border-radius: 4px;
  max-width: 440px;
  width: 100%;
  background: white;
  padding: ${props => props.theme.space[5]};
  text-align: center;
`;

class LogInView extends PureComponent {
  static mapStateToProps = state => ({
    errorMessage: state.auth.errorMessage,
    isSubmitting: state.auth.isAuthenticating,
    isAuthenticated: state.auth.isAuthenticated,
    user: userSelector(state),
  });

  static mapDispatchToProps = dispatch => ({
    loginWith: (username, password) => dispatch(login(username, password)),
  });

  usernameRef = React.createRef();

  passwordRef = React.createRef();

  state = {
    username: '',
    password: '',
  };

  handleUsernameChange = (e) => {
    this.setState({ username: e.target.value });
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { loginWith } = this.props;
    const { username, password } = this.state;

    if (isEmpty(username)) {
      if (this.usernameRef.current) {
        this.usernameRef.current.handleFocus();
      }
      return;
    } if (isEmpty(password)) {
      if (this.passwordRef.current) {
        this.passwordRef.current.handleFocus();
      }
      return;
    }

    // return loginWith(username, password); not sure i understand why this is a return TODO
    loginWith(username, password);
  };

  render() {
    const {
      errorMessage, location, isSubmitting, isAuthenticated, user,
    } = this.props;
    const { username, password } = this.state;

    if (isAuthenticated) {
      if (user && user.role === ROLES.BRANCH_MANAGER) {
        return <Redirect to={`/${DEFAULT_PATHS_FOR_ROLE[user.role]}`} />;
      }
      const nextPath = (location.state && location.state.nextPathname) || '/';
      return <Redirect to={nextPath} />;
    }
    const { BRANDED_LOGO_URL } = featureFlags;
    return (
      <Centered flex justifyContent="center" alignItems="center">
        <Panel>
          <Head title="Log In" />
          {BRANDED_LOGO_URL && <BrandedLogo url={ehaiLogo} height={72} />}
          <form onSubmit={this.handleSubmit}>
            {errorMessage.length > 0 && (
              <Box marginBottom={4}>
                <Alert>{errorMessage}</Alert>
              </Box>
            )}
            <Box marginTop={4} marginBottom={4}>
              <TextField
                ref={this.usernameRef}
                onChange={this.handleUsernameChange}
                name="username"
                type="text"
                value={username}
                placeholder="Username"
              />
            </Box>
            <Box marginBottom={4}>
              <TextField
                ref={this.passwordRef}
                onChange={this.handlePasswordChange}
                name="password"
                type="password"
                value={password}
                placeholder="Password"
              />
            </Box>
            <Button primary type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Logging In...' : 'Log In'}
            </Button>
          </form>
        </Panel>
      </Centered>
    );
  }
}

export default connect(
  LogInView.mapStateToProps,
  LogInView.mapDispatchToProps,
)(LogInView);

LogInView.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  loginWith: PropTypes.func.isRequired,
  user: PropTypes.shape({
    role: PropTypes.string,
  }),
  // eslint-disable-next-line react/require-default-props
  location: PropTypes.shape({}),
};

LogInView.defaultProps = {
  user: null,
};
